module.exports = __webpack_public_path__ + "img/yd-fs-img.17969d05.png";